/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommandDto } from '../../models/command-dto';
import { ControllerStatusDto } from '../../models/controller-status-dto';

export interface ExchangeStatusForCommandPost$Plain$Params {
      body?: ControllerStatusDto
}

export function exchangeStatusForCommandPost$Plain(http: HttpClient, rootUrl: string, params?: ExchangeStatusForCommandPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CommandDto>> {
  const rb = new RequestBuilder(rootUrl, exchangeStatusForCommandPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommandDto>;
    })
  );
}

exchangeStatusForCommandPost$Plain.PATH = '/ExchangeStatusForCommand';
